<template>
  <div>
    <DoughnutChart
      v-if="loaded"
      class="chart"
      :style="styleChart"
      :chart-data="datacollection"
      :options="options"
    >
    </DoughnutChart>
  </div>
</template>

<script>
// import Chart from 'chart.js'
import APIService from '../../APIService'
export default {
  components: {
    DoughnutChart: () => import('./DoughnutChart.js')
  },
  props: {
    queryId: {
      type: String,
      default: null
    },
    schema: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: null
    },
    styleChart: {
      type: String,
      default: null
    },
    tooltipPartener: {
      type: String,
      default: 'Partener: '
    },
    tooltipNrDoc: {
      type: String,
      default: 'Numar documente: '
    },
    tooltipPercent: {
      type: String,
      default: 'Procentaj: '
    }
  },
  data() {
    const vm = this
    return {
      total: 0,
      loaded: false,
      datacollection: null,
      display: true,
      backgroundColor: [
        '#A989C5',
        '#5CC2F9',
        '#509EE3',
        '#88BF4D',
        '#98D9D9',
        '#ff9999',
        '#ffaa80',
        '#00e600',
        '#F9D45C',
        '#7070db'
      ],
      labels: [],
      options: {
        cutoutPercentage: 60,

        centertext: '123',
        maintainAspectRatio: false,
        responsive: 'true',
        legend: {
          position: 'left',
          labels: {
            fontStyle: 'bold',
            usePointStyle: true
          },
          onHover: function(event, legendItem) {
            var chart = this.chart
            var index = legendItem.index
            var segment = chart.getDatasetMeta(0).data[index]
            chart.tooltip._active = [segment]
            chart.tooltip.update()
            chart.draw()
          },
          onLeave: function() {
            var chart = this.chart
            chart.tooltip._active = []
            chart.tooltip.update()
            chart.draw()
          }
        },
        title: {
          display: true,
          text: this.title,
          fontSize: 15
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function(tooltipItem, data) {
              var allData = data.datasets[tooltipItem.datasetIndex].data
              var tooltipLabel = data.labels[tooltipItem.index]
              var tooltipData = allData[tooltipItem.index]
              var total = 0
              for (var i in allData) {
                total += allData[i]
              }
              var tooltipPercentage = Math.round((tooltipData / total) * 100)
              var tooltipAfter = tooltipLabel.replace('%', '')
              return [
                vm.tooltipPartener +
                  tooltipAfter.replace(tooltipPercentage, ''),
                vm.tooltipNrDoc + tooltipData,
                vm.tooltipPercent + tooltipPercentage + '%'
              ]
            }
          }
        }
      },
      dataVal: [],
      items: null
    }
  },

  created() {
    APIService.getQueryData(this.queryId)
      .then((res) => {
        this.items = res.data
        this.items.forEach((element) => {
          this.total += element.count
        })
        this.items.forEach((element) => {
          this.dataVal.push(element.count)

          this.tooltipPercentage = Math.round(
            (element.count / this.total) * 100
          )
          this.labels.push(element._id + '    ' + this.tooltipPercentage + '%')
        })
        this.fillData()
        this.loaded = true
      })
      .catch((ex) => {
        console.log(ex.response)
      })
  },

  mounted() {
    this.loaded = false
  },

  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labels,
        datasets: [
          {
            label: this.labels,
            backgroundColor: this.backgroundColor,
            data: this.dataVal,
            hoverBackgroundColor: this.backgroundColor,
            hoverBorderColor: this.backgroundColor
          }
        ]
      }
    }
  }
}
</script>
<style scoped>
.chart {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 8px;
  padding: 10px;
}
</style>
